import { jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDropdownGroupContext } from '../../contexts/group-context.mjs';
import { dropdownLabel } from '../../shared/styles/label.vanilla.mjs';

const DropdownGroupTitle = forwardRef(({ className: classNameFromProps, ...props }, forwardedRef) => {
  const { id } = useDropdownGroupContext("Title");
  const className = classNames(dropdownLabel, classNameFromProps);
  return /* @__PURE__ */ jsx(
    Primitive.span,
    {
      id,
      "data-scope": "dropdown",
      "data-part": "group-title",
      className,
      ref: forwardedRef,
      ...props
    }
  );
});

export { DropdownGroupTitle };
//# sourceMappingURL=GroupTitle.mjs.map
